var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._l((_vm.value),function(val,index){return _c('b-form-group',{key:index,attrs:{"label":`value[${index}]`,"label-cols-sm":"1"}},[_c('b-form-input',{attrs:{"value":val}})],1)}),_vm._v(" "),_c('b-btn',{on:{"click":function($event){$event.preventDefault();return _vm.value.push(null)}}},[_vm._v("Add")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }